import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.06141 6.45417V15.1792C6.06141 15.5649 6.22268 15.9347 6.50974 16.2074C6.7968 16.4801 7.18614 16.6333 7.59211 16.6333H19.8377C20.2437 16.6333 20.6331 16.4801 20.9201 16.2074C21.2072 15.9347 21.3684 15.5649 21.3684 15.1792V6.45417C21.3684 6.0685 21.2072 5.69863 20.9201 5.42592C20.6331 5.15321 20.2437 5 19.8377 5H7.59211C7.18614 5 6.7968 5.15321 6.50974 5.42592C6.22268 5.69863 6.06141 6.0685 6.06141 6.45417ZM13.3322 7.90834H19.8377V15.1792H7.59211V7.90834H13.3322ZM4.5307 16.6333V7.90834C4.12473 7.90834 3.73539 8.06154 3.44833 8.33425C3.16127 8.60696 3 8.97684 3 9.36251V16.6333C3 17.4047 3.32254 18.1444 3.89666 18.6899C4.47079 19.2353 5.24947 19.5417 6.06141 19.5417H16.7763C17.1823 19.5417 17.5716 19.3885 17.8587 19.1158C18.1458 18.8431 18.307 18.4732 18.307 18.0875H6.06141C5.65544 18.0875 5.2661 17.9343 4.97903 17.6616C4.69197 17.3889 4.5307 17.019 4.5307 16.6333Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgTourScreensOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgTourScreensOutline;
